import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {MaterialNode} from "#template/nodes/material/material-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {MaterialGraph} from "@cm/material-nodes"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import {FlattenMaterial} from "#template/runtime-graph/nodes/flatten-material"

export type MaterialGraphReferenceParameters = {
    materialGraph: MaterialGraph
}

const materialGraphReferenceDefinition: TemplateNodeDefinition<MaterialGraphReferenceParameters> = {
    nodeClass: "MaterialGraphReference",
    validation: {
        parameters: z.object({
            materialGraph: z.instanceof(MaterialGraph),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MaterialGraphReference extends MaterialNode<MaterialGraphReferenceParameters> {
    public override get definition() {
        return materialGraphReferenceDefinition
    }

    public override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MaterialGraph | null> {
        const {templateContext} = evaluator
        const {sceneManager} = templateContext

        return scope.node(FlattenMaterial, {
            sceneManager,
            input: this.parameters.materialGraph,
        }).output
    }
}
